import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

export interface LiveCameraOption {
  id: string;
  name: string;
  monitored: boolean;
}

interface LiveCameraSelectProps {
  options: LiveCameraOption[];
  value?: string;
  onChange: (id: string) => void;
}

export function LiveCameraSelect({ options, value, onChange }: LiveCameraSelectProps) {
  const monitored = options.filter((o) => o.monitored);
  const unmonitored = options.filter((o) => !o.monitored);

  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger className="h-8 min-w-[140px] max-w-[200px] truncate border-none bg-muted/10 text-xs font-semibold text-lime hover:bg-muted/20">
        <SelectValue placeholder="Select live feed" className="text-lime" />
      </SelectTrigger>
      <SelectContent className="h-full bg-[#111] text-lime">
        {monitored.length > 0 && (
          <SelectGroup>
            <SelectLabel className="text-xs text-lime/60">Monitored</SelectLabel>
            {monitored.map((o) => (
              <SelectItem key={o.id} value={o.id} title={o.name}>
                <span className="truncate">{o.name}</span>
              </SelectItem>
            ))}
          </SelectGroup>
        )}
        {unmonitored.length > 0 && (
          <SelectGroup>
            <SelectLabel className="text-xs text-lime/60">Unmonitored</SelectLabel>
            {unmonitored.map((o) => (
              <SelectItem key={o.id} value={o.id} title={o.name}>
                <span className="truncate">{o.name}</span>
              </SelectItem>
            ))}
          </SelectGroup>
        )}
      </SelectContent>
    </Select>
  );
}
